import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, computed } from '@angular/core'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { CommonService } from 'src/app/services/common/common.service'
import cloneDeep from 'lodash/cloneDeep'

@Component({
  selector: 'app-multiple-file-selector',
  templateUrl: './multiple-file-selector.component.html',
  styleUrls: ['./multiple-file-selector.component.scss']
})
export class MultipleFileSelectorComponent implements OnInit {
  private _fileInput: ElementRef

  @ViewChild('fileInput', { static: false, read: ElementRef })
  set fileInput(value: ElementRef) {
    this._fileInput = value
  }
  @Output() chooseFiles: EventEmitter<File[]> = new EventEmitter<File[]>()
  @Output() chooseFile: EventEmitter<File> = new EventEmitter<File>()
  @Output() removeFiles: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Input('maxAllowedSizeInBytes') maxAllowedSizeInBytes = GlobalConstants.FILE_UPLOAD_CONFIG.maxAllowedSizeInBytes
  @Input('inputAccept') inputAccept = GlobalConstants.FILE_UPLOAD_CONFIG.allowedInputAccept
  @Input('acceptedFormatMsg') acceptedFormatMsg = `Accepted File Formats: PNG,JPEG,PDF,WORD,EML;
  Max Size: ${this.maxAllowedSizeInBytes / (1024 * 1024)} MB;`
  @Input('allowedTypes') allowedTypes = GlobalConstants.FILE_UPLOAD_CONFIG.allowedFileMimeTypes
  @Input('isMultiple') isMultiple = true
  @Input('enableMultiSelect') enableMultiSelect = false

  uploadedFiles: File[] = []
  showFileUploadBox = true
  errorMsg = computed(() => {
    const uniqueAllowedTypes = [
      ...new Set(this.allowedTypes.map((_) => GlobalConstants.FILE_UPLOAD_CONFIG.documentAndMimeTypeMapping[_]))
    ]
    return `Some files are not valid. Please select only ${uniqueAllowedTypes.join(
      ', '
    )} files, with a maximum size of ${this.maxAllowedSizeInBytes / (1024 * 1024)} MB.`
  })

  constructor(private cs: CommonService) {}

  ngOnInit() {}

  clearSelectedFiles() {
    this.resetFileInput()
    this.removeFiles.emit(true)
    this.showFileUploadBox = true
    this.uploadedFiles = []
    this.chooseFiles.emit(this.uploadedFiles)
  }

  handleFileInput(input: File | FileList) {
    const files: File[] = this.enableMultiSelect && input instanceof FileList ? Array.from(input) : [input as File]

    if (this.enableMultiSelect && files.length > GlobalConstants.FILE_UPLOAD_CONFIG.maxFilesPerSelection) {
      this.resetFileInput()
      this.cs.showError(
        `You can select up to ${GlobalConstants.FILE_UPLOAD_CONFIG.maxFilesPerSelection} files at a time.`
      )
      return
    }

    files.forEach((file) => this.addFile(file))
  }

  private addFile(file: File) {
    const isValidFile = this.allowedTypes.includes(file.type) && file.size <= this.maxAllowedSizeInBytes
    if (!isValidFile) {
      this.resetFileInput()
      this.cs.showError(this.errorMsg())
      return
    }

    if (
      this.uploadedFiles.some(
        (uploadedFile) =>
          uploadedFile.name === file.name && uploadedFile.type === file.type && uploadedFile.size === file.size
      )
    ) {
      return this.cs.showError('Duplicate file')
    }

    this.uploadedFiles.push(file)
    this.chooseFiles.emit(this.uploadedFiles)
    this.chooseFile.emit(file)
    this.showFileUploadBox = false
    this.uploadedFiles = cloneDeep(this.uploadedFiles)
  }

  private resetFileInput() {
    if (this._fileInput) {
      this._fileInput.nativeElement.value = ''
    }
  }

  removeFile(index: number) {
    this.uploadedFiles.splice(index, 1)
    this.chooseFiles.emit(this.uploadedFiles)
  }

  addMoreFiles() {
    this.showFileUploadBox = true
  }

  findAllowedFileTypes() {}
}
